import { useCallback, useState } from 'react';

export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 10;

/**
 * Default rows-per-page for data list tables (employees, instances, payslips,
 * technical logs). Must be one of the pagination options
 * (`ROWS_PER_PAGE_OPTIONS`: 10 / 25 / 50 / 100).
 */
export const DEFAULT_TABLE_PAGE_SIZE = 25;

export interface UsePaginationStateReturn {
  page: number;
  limit: number;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  resetPage: () => void;
}

/**
 * Generic hook for managing table pagination state.
 * Provides page, limit, and a resetPage helper for resetting to page 1
 * when sort or filter state changes.
 */
export function usePaginationState(defaultLimit = DEFAULT_LIMIT): UsePaginationStateReturn {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [limit, setLimit] = useState(defaultLimit);
  const resetPage = useCallback(() => setPage(DEFAULT_PAGE), []);

  return { page, limit, setPage, setLimit, resetPage };
}
